module.exports = __webpack_public_path__ + "img/sw_ondo.4039eb37.svg";